import { Location, LocationControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

interface useProviderGroupLocationUpdateParam {
  location: Location;
  xTENANTID?: string;
}

/**
 * query to handle edit provider group profile
 * @author rajkumar rathod
 */
export const useProviderGroupLocationUpdate = () =>
  useMutationWithLoading((param: useProviderGroupLocationUpdateParam) =>
    new LocationControllerApi(getConfigObject()).updateLocation(
      param.location,
      param.xTENANTID
    )
  );
